import React, { useContext } from "react";
import { Controller } from "react-hook-form";
import "./Multicheckbox.css"; // Ensure styles are applied
import { ThemeContext } from "../../../../..";

const CheckboxGroup = ({ options, name, control, parentLabel, webaccess }) => {
  console.log("Received Parent Label:", parentLabel);
  console.log(webaccess, "hasWebAccess");
  const { theme } =useContext(ThemeContext);
  // Debugging

  return (
    <div className="checkbox-group-container">
      {parentLabel && (
        <label className="checkbox-parent-label"  style={{ color: webaccess ? "" : "black" }}>
          {parentLabel}
        </label>
      )}
      <div className="checkbox-group div-space-adminrole">
        {options.map((option) => (
          <Controller
            key={`${name}.${option.name}`} // Ensure a unique key
            name={`${name}.${option.name}`} // ✅ Ensure unique name for each checkbox
            control={control}
            render={({ field: { onChange, value } }) => (
              <label
                className="checkbox-container"
                style={{ color: webaccess ? "" : theme === "light" ? "black" : "black" }} // Light gray when disabled
              >
                <span  style={{ color: webaccess ? "#6c659d" : theme === "light" ? "black" : "black" }} className="dynamic__checkbox--label label-adminrole">
                  {option.label}
                </span>
                <input
                  className="check-adminrole"
                  type="checkbox"
                  checked={value || false}
                  onChange={(e) => onChange(e.target.checked)}
                  disabled={webaccess}
                />
              </label>
            )}
          />
        ))}
      </div>
    </div>
  );
};

export default CheckboxGroup;
